import useDialog from './hooks/useDialog'
import Typography from '@mui/material/Typography'
import Dialog from '../control/Dialog'
import Button from '../control/Button'

type DialogFullScreenPlaygroundType = ReturnType<typeof useDialog>

const DialogFullScreenPlaygroundView = (props: DialogFullScreenPlaygroundType) => {
    const { openDialog, onOpen, onClose } = props

    return (
        <div>
            <Typography variant="h3" gutterBottom>
                Control: Dialog Full Screen
            </Typography>
            <Button onClick={onOpen}>Open dialog full-screen</Button>
            <Dialog fullScreen isOpen={openDialog} onClose={onClose} title={'Title'}>
                <Typography gutterBottom>
                    Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas
                    eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                </Typography>
                <Typography gutterBottom>
                    Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue
                    laoreet rutrum faucibus dolor auctor.
                </Typography>
                <Typography gutterBottom>
                    Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.
                </Typography>
            </Dialog>
        </div>
    )
}

//Controller
const DialogFullScreenPlayground = () => {
    const dialogModel = useDialog()
    return <DialogFullScreenPlaygroundView {...dialogModel} />
}

export default DialogFullScreenPlayground
